import React from "react"
import { Row, Container, Card } from "react-bootstrap"
//import { StaticImage } from "gatsby-plugin-image"
import { GatsbyImage } from "gatsby-plugin-image"
import { graphql, Link } from "gatsby"
import Slider from "react-slick";
import Img from "gatsby-image";

import Layout from "../components/layout"
import Seo from "../components/seo"
import IndexCard from "../components/indexCard"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const IndexPage = ( { data : { images } } ) => {

  var imagearr = []
  var imageFluid = []
  for (var img of images.edges) {
    imagearr[img.node.name] = img.node.childImageSharp.gatsbyImageData
    imageFluid[img.node.name] = img.node.childImageSharp.fluid
  }

  const slider_settings = {
    arrows: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  //<StaticImage src="../images/index-page/campfire1280x720.jpg" alt="Campfire cooking" loading="eager"/>
//<StaticImage src="../images/index-page/cookbook.jpg" alt="Cookbook" loading="eager"/>
//<StaticImage src="../images/index-page/ilovecooking1280x720.jpg" alt="Kitchen gadget graphic" loading="eager"/>
// <GatsbyImage image={imagearr["cookbook"]} alt="Kitchen gadget graphic" />
  return (
  <Layout pageInfo={{ pageName: "index" }}>
    <Seo title="Home" keywords={[`recipes`]} description="Great website with great recipes!" url="" />
    <Container className="text-center">
      <Row className="justify-content-center d-flex flex-wrap p-4">
      <Card className="index-card-top p-3">
        <Card.Body>
      <Slider {...slider_settings}>    
          <div>       
          <Link to="/camping-cookbook/">
            <Img fluid={imageFluid["campfire1280x720"]} alt="Campfire cooking" /> 
            <p className="pt-4">
              <h4>View our online Camping Cookbook</h4>
              Our camping cookbook is a great source of recipes for your next outing.
            </p>
          </Link>
          
          </div>
          <div>
          <Link to="/menke-family-cookbook/">
            <Img fluid={imageFluid["cookbook"]} alt="Cookbook" /> 
            <p className="pt-4">
              <h4>View our online Family Cookbook</h4>
              Our family cookbook is a fun, precious resource of old and new family recipes.
            </p>
          </Link>
          </div>

          <div>
          <Link to="/recipe-index/">
            <Img fluid={imageFluid["ilovecooking1280x720"]} alt="Kitchen gadget graphic" /> 
            <p className="pt-4">
              <h4>Browse over 600 Recipes</h4>
              Not sure what to cook? Look for your next recipe by browsing our categories.
            </p>
          </Link>
          </div>
      </Slider>
      </Card.Body>
      </Card>
      </Row>

      <Row>
      <div className="d-flex justify-content-center flex-wrap pt-4">
      <IndexCard title="Browse Recipes" 
        text="Find recipes by category"
        image={imagearr["ilovecooking2"]}
        imageAlt = "Grid of kitchen gadgets" 
        linkTo="/recipe-index"
      />

      <IndexCard title="Camping Cookbook" 
        text = "Our online camping cookbook is a great source of recipes for your next outing."
        image={imagearr["campfire2"]}
        imageAlt="Campfire" 
        linkTo="/camping-cookbook/"
      />

      <IndexCard title="Family Cookbook" 
        text = "Our online family cookbook has lots of great favorite recipes. We hope you enjoy!"
        image={imagearr["cookbook2"]}
        imageAlt="Cookbook" 
        linkTo="/menke-family-cookbook/"
      />

      <IndexCard title="Quiche Recipe" 
        text = "Simply the best French quiche recipe ever!"
        image={imagearr["quiche"]}
        imageAlt="Quiche" 
        linkTo="/recipes/view/quiche/"
      />

      <IndexCard title="Blueberry Cobbler" 
        text = "If you are on the Guntflint Trail (in Minnesota) and have picked your own blueberries, this is the recipe for you."
        image={imagearr["blueberry-cobbler"]}
        imageAlt="Blueberry Cobbler" 
        linkTo="/recipes/view/gunflint-blueberry-cobbler/"
      />

      <IndexCard title="Seasoned Hamburgers" 
        text = "This recipe turns basic hamburgers into the best hamburgers"
        image={imagearr["seasoned-hamburger"]}
        imageAlt="Seasoned Hamburger" 
        linkTo="/recipes/view/seasoned-hamburgers/"
      />

      </div>
      
  
      </Row>
    </Container>
  </Layout>
 )
}

//<IndexCard title="Dutch Oven Recipes" 
//        text = "We have a bunch of Dutch oven recipes. Many are super easy."
//        image={imagearr["dutch-oven-fruit-cobbler"]}
//        imageAlt="Dutch Oven Fruit Cobbler" 
//        linkTo="/recipes/view/category/dutch-oven/"
//      />

export default IndexPage

export const indexPageQuery = graphql`
  query indexPageImages {
    images: allFile (filter: { sourceInstanceName: { eq: "index-page-images" }}) {
      edges {
        node {
          dir
          ext
          sourceInstanceName
          name
          childImageSharp {
            gatsbyImageData 
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`

//      <IndexCard title="Camping Cookbook" 
//        text = "The perfect way to plan and create great meals for camping. You will be the hero at camp."
//        image={imagearr["campfire2"]}
//        imageAlt="Campfire" 
//        linkTo="/camping-cookbook/"
//      />

//        <IndexCard title="Dutch Oven Cooking Tips" 
//          text = "Wondering how to cook in a cast iron Dutch oven at a campfire? This is a fun way to cook and you can make cakes, cookies, soups, and more!"
//          image={imagearr["dutch-oven2"]}
//          imageAlt="Dutch Oven with Coals" 
//          linkTo="/dutch-oven-cooking-tips/"
//        />